import React, { useReducer, useEffect } from "react";
import axios from "axios";

import URL from "../../common/variables";
import FormNameProfile from "../FormNameProfile/FormNameProfile";
import UserSection from "../UserSection/UserSection";

import UserContext from "./UserContext";
import { WelcomeUserReducer } from "./WelcomeUserReducer";

import "./WelcomeUser.scss";

const WelcomeUser = () => {
  const initialState = {
    user: {},
    isLoading: true,
    isError: false,
    isErrorMessage: [],
  };
  const [state, dispatch] = useReducer(WelcomeUserReducer, initialState);

  useEffect(() => {
    axios
      .get(`${URL}/rest-auth/user/`)
      .then((response) => axios.get(`${URL}/user/${response.data.pk}`))
      .then((response) =>
        dispatch({ type: "GET_USER_DATA", data: response.data })
      )
      .catch((err) => {
        if (err.response.status === 404) {
          dispatch({
            type: "GET_USER_ERROR",
            message: `404 endpoint not found at ${endpoint}`,
          });
        }
      });
  }, []);

  const SwitchSection = () => {
    if (
      (state.user.first_name === "" && state.user.last_name === "") ||
      state.user.perfil === null
    ) {
      return <FormNameProfile />;
    }
    return <UserSection />;
  };

  const showErrors = () => (
    <div>
      {state.isErrorMessage.map((txt, pos) => (
        <div key={pos}>{txt}</div>
      ))}
    </div>
  );

  return (
    <UserContext.Provider value={state.user}>
      {state.isLoading && <p className="text-center">Cargando...</p>}
      {state.isError && showErrors(state.isErrorMessage)}
      {!state.isLoading && !state.isError && <SwitchSection />}
    </UserContext.Provider>
  );
};

export default WelcomeUser;
